<template>
  <v-container>
    <v-content>
      <h1 class="text-center primary--text">One Process</h1>
    </v-content>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab key="storno">
              Storno
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item key="storno">
              <v-card flat>
                <v-card-text>
                  <Storno />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Storno from '../components/oneProcess/Storno.vue'
export default {
  components: {
    Storno
  },
  data() {
    return {
      tab: null
    }
  }
}
</script>
